import React from 'react'

export default function CssIcon({cls}) {
    return (
        <svg
            className={cls}
            xmlns="http://www.w3.org/2000/svg"
            
            enableBackground="new 0 0 512 512"
            viewBox="0 0 512 512"
        >
            <g xmlns="http://www.w3.org/2000/svg">
                <path 
                    fill="#004ce8"
                    d="M437.367 100.62l-33.046 370.199L255.778 512l-148.134-41.123L74.633 100.62z"
                    data-original="#004ce8"
                ></path>
                <path
                    fill="#0065f4"
                    d="M376.03 447.246l28.24-316.352H256v349.629z"
                    data-original="#0065f4"
                ></path>
                <g fill="#ebebeb">
                    <path
                        d="M150.31 268.217l4.07 45.41H256l19.533-22.705L256 268.217z"
                        data-original="#ebebeb"
                    ></path>
                    <path
                        d="M256 176.305H142.132l4.128 45.411H256l19.533-22.706z"
                        data-original="#ebebeb"
                    ></path>
                    <path
                        d="M256 433.399l19.533-24.081L256 386.153l-.199.053-50.574-13.656-3.233-36.217h-45.585l6.362 71.301 93.02 25.823z"
                        data-original="#ebebeb"
                    ></path>
                </g>
                <path
                    className='fill-black dark:fill-white'
                    d="M160 0h55v23h-32v23h32v23h-55z"
                    data-original="#000000"
                ></path>
                <path
                    className='fill-black dark:fill-white'
                    d="M226 0h55v20h-32v4h32v46h-55V49h32v-4h-32z"
                    data-original="#000000"
                ></path>
                <path
                  className='fill-black dark:fill-white'
                    d="M292 0h55v20h-32v4h32v46h-55V49h32v-4h-32z"
                    data-original="#000000"
                ></path>
                <path
                    fill="#fff"
                    d="M311.761 313.627l-5.271 58.894-50.647 13.67v47.244l93.094-25.801.683-7.672 10.671-119.551 1.108-12.194 8.198-91.912H255.843v45.411h63.988l-4.132 46.501h-59.856v45.41z"
                    data-original="#ffffff"
                ></path>
            </g>
        </svg>
    )
}
